<div class="container">
  <div class="content">
    <div class="dialog-headline">
      <h3>Trigger Import Run</h3>
    </div>
    @if (isLoading) {
      <div class="loading-spinner">
        <importer-app-turbine [contrast]="true"></importer-app-turbine>
      </div>
    }
    @if (!isLoading) {
      <div class="box">
        <div class="group">
          <div class="flex-container">
            <importer-dropdown
              label="File Type"
              [items]="entities"
              [shadow]="true"
              [displayFn]="dropdownDisplayFn"
              [disabled]="!entities.length"
              (selectionChange)="applySelectionChange($event)"></importer-dropdown>
          </div>
        </div>
        <div class="buttons">
          <coin-v2-button
            [type]="'secondary'"
            [icon]="'close'"
            [iconPos]="'right'"
            [text]="'Cancel'"
            (click)="close()"></coin-v2-button>

          <coin-v2-button
            [type]="'primary'"
            [icon]="'play_arrow'"
            [iconPos]="'right'"
            [text]="'Trigger Import Run'"
            [disabled]="!selectedFileType"
            (click)="openConfirmation()"></coin-v2-button>
        </div>
      </div>
    }
  </div>
</div>
